import { createSlice } from '@reduxjs/toolkit';

// Load initial config from localStorage if available
const loadConfigFromStorage = () => {
  try {
    const storedConfig = localStorage.getItem('app_config');
    return storedConfig ? JSON.parse(storedConfig) : null;
  } catch (error) {
    console.error('Error loading config from localStorage:', error);
    return null;
  }
};

const initialState = {
  config: loadConfigFromStorage(),
  loading: false,
  error: null,
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig: (state, action) => {
      state.config = action.payload;
      state.loading = false;
      state.error = null;
      // console.log("action.payload",action.payload)
      // Save to localStorage only if not on public-trip page
      if (!window.location.pathname.includes('/public')) {
        try {
          localStorage.setItem('app_config', JSON.stringify(action.payload));
        } catch (error) {
          console.error('Error saving config to localStorage:', error);
        }
      }
    },
    setConfigLoading: (state, action) => {
      state.loading = action.payload;
    },
    setConfigError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearConfig: (state) => {
      state.config = null;
      state.loading = false;
      state.error = null;
      // Remove from localStorage
      localStorage.removeItem('app_config');
    },
  },
});

export const { setConfig, setConfigLoading, setConfigError, clearConfig } = configSlice.actions;

export default configSlice.reducer; 